import { XIcon } from '@phosphor-icons/react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

const ModalCloseButton = ({ onClick, className }) => (
  <Button
    variant="outline"
    size="icon"
    onClick={onClick}
    className={cn(
      'absolute left-1/2 flex h-10 w-10 -translate-x-1/2 -top-20 items-center justify-center rounded-full q3-glass z-50',
      className,
    )}
    aria-label="Close"
  >
    <XIcon size={24} className="text-[var(--q3-neutral-default)]" />
  </Button>
);

export default ModalCloseButton;
